import React, { useEffect, useRef } from 'react';
import WebUniversalNewEx, { WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import UnitConversionEdit from './UnitConversionEdit';

export default function UnitConversion(props: any) {

    const ref = useRef<any>(undefined);
    const { closeModal, data } = props;

    /** api服务id */
    const apiId = 'unitConversion';

    useEffect(() => {
        //同步获取数据 async - await
        const fetchData = async () => {
        }
        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    //表头
    const columnsHead = [
        {
            title: '产品',
            dataIndex: 'productName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.product.productName}</div>
                )
            }
        },
        {
            title: '换算系数',
            dataIndex: 'conversionFactor',
        },
        {
            title: '单位',
            dataIndex: 'productUnitName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.productUnit.productUnitName}</div>
                )
            }
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
    ];


    const columns = columnsheadId
        .concat(columnsHead as []);


    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '单位换算',
        apiId,
        columns,
        showStates: true,
        pagination: true,
        showQuery: false,
        EditComponent: UnitConversionEdit,
        sendPageData: {
            productId: data.id,
            productUnitId: data.productUnitId,
            productUnitName: data.productUnitName
        },
        mountDataOptions: {
            userMount: {
                isDept: true
            }
        }
    };

    return (
        <>
            <AntDraggableModal
                title={'单位换算'}
                open={true}
                okText='关闭'
                // cancelText={stringHandle.isUndefined()}
                cancelButtonProps={{ style: { display: "none" } }}
                onOk={() => closeModal(true)}
                closable={false}
                maskClosable={false}
                width={1200}>
                <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>
            </AntDraggableModal>
        </>
    )
}